<template>
  <div class="mt-2">
    <b-form @submit.prevent="startSearch()">
      <b-form-group
      label="Straße & Hausnummer:"
      >
        <b-form-input
          name="street"
          :state="address.street ? true : false"
          v-model="address.street"
          size="sm"
          type="text"
          placeholder="Straße eingeben..."
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
      label="Postleitzahl:"
      >
        <b-form-input
          name="zipcode"
          :state="address.zipcode ? true : false"
          v-model="address.zipcode"
          type="text"
          size="sm"
          placeholder="Postleitzahl eingeben..."
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
      label="Stadt:"
      >
        <b-form-input
          name="city"
          :state="address.city ? true : false"
          v-model="address.city"
          type="text"
          size="sm"
          placeholder="Stadt eingeben..."
          required
        ></b-form-input>
      </b-form-group>

      <b-button @click="startSearch">Adresse bestätigen <b-spinner v-if="searching" small label="Spinning"></b-spinner> <font-awesome-icon v-if="found" class="text-success" icon="check" /> </b-button>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'GooglePlacesAutocomplete',

  props: {

  },
  components: {

  },
  data: () => {
    return {
      address: {},
      location: '',
      searchResults: [],
      service: null,
      searching: false,
      found: false
    }
  },
  watch: {
    location (newValue) {
      if (newValue && this.service) {
        this.service.getPlacePredictions({
          input: this.location,
          componentRestrictions: {country: 'de'},
          types: ['address']
        }, this.displaySuggestions)
      }
    }
  },
  computed: {
   adressData(){
     return this.$store.getters.adressData
   }
  },
  mounted(){
    
    if(localStorage.getItem('adressData_delivery')){
      this.location = JSON.parse(localStorage.getItem('adressData_delivery'))
    }
    this.MapsInit()
  },
  beforeDestroy(){

  },
  methods: {
    startSearch(){
     // if(!this.location) return
      this.location = this.address.street + ',' + this.address.zipcode + ',' + this.address.city
      this.getLocation()
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction.description) 
    },
    getLocation(){
      if(!this.location) return
      this.searching = true
      this.found = false
      axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=germany,' + this.location + '&region=de&key=AIzaSyD_9KM0IcRD81nQUVZKNFVW_d5NEJU3SIM')
            .then(
              (res) => {

                  var addressData = {
                    addressData: res,
                    latitude: res.data.results[0].geometry.location.lat,
                    locality: res.data.results[0].formatted_address,
                    longitude: res.data.results[0].geometry.location.lng,
                  }
                  this.$store.dispatch('getCompany')
                  localStorage.setItem('adressData_delivery', JSON.stringify(addressData))
                  this.$emit('getAddressData', addressData)
                  this.searching = false
                  this.found = true
              }
            )
            .catch(
              error => {
                  console.log(error)
                  this.searching = false
                  this.found = false
            }
          )
    },
    
  }
}
</script>